// 195 стран: 193 члена ООН, Ватикан и Палестина. Часть света — из flag-icons/country.json.
// Россия, Турция, Кипр и т. п. — как там указано.
export const CONTINENTS: { name: string; codes: string[] }[] = [
  {
    name: 'Европа',
    codes: 'AL AD AT BY BE BA BG HR CY CZ DK EE FI FR DE GR HU IS IE IT LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SE CH UA GB VA'.split(' '),
  },
  {
    name: 'Азия',
    codes: 'AF AM AZ BH BD BT BN KH CN GE IN ID IR IQ IL JP JO KZ KP KR KW KG LA LB MY MV MN MM NP OM PK PH QA SA SG LK SY TJ TH TL TR TM AE UZ VN YE PS'.split(' '),
  },
  {
    name: 'Африка',
    codes: 'DZ AO BJ BW BF BI CV CM CF TD KM CG CD CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU MA MZ NA NE NG RW ST SN SC SL SO ZA SS SD TZ TG TN UG ZM ZW'.split(' '),
  },
  {
    name: 'Северная Америка',
    codes: 'AG BS BB BZ CA CR CU DM DO SV GD GT HT HN JM MX NI PA KN LC VC US'.split(' '),
  },
  {
    name: 'Южная Америка',
    codes: 'AR BO BR CL CO EC GY PY PE SR TT UY VE'.split(' '),
  },
  {
    name: 'Океания',
    codes: 'AU FJ KI MH FM NR NZ PW PG WS SB TO TV VU'.split(' '),
  },
];
